module.exports = __webpack_public_path__ + "static/media/codelearn.2c8dfa1e.svg";